<template>
  <v-card height="430" class="pa-8 half-radius overflow-auto shadow">
    <v-card-title class="px-0 pt-0">
      <v-avatar class="shadow circle" size="50">
        <v-img height="36" contain :src="src" alt="Arches Dev"></v-img>
      </v-avatar>
      <span class="ml-4 custom-text">
        <slot name="title"></slot>
      </span>
    </v-card-title>
    <v-card-text v-if="hidden">
      <v-row justify="center" class="mt-8">
        <v-col cols="12" class="text-center">
          <v-icon class="mx-auto" size="152">$vuetify.icons.appInvisible</v-icon>
        </v-col>
        <v-col class="text-center font-weight-light body-2" cols="12"
          >You can check the answers only when you finish the exercise</v-col
        >
      </v-row>
    </v-card-text>
    <v-card-text v-else class="custom-rich-text">
      <app-editor :value="value" @input="$emit('input', $event)" :editable="editable"></app-editor>
    </v-card-text>
    <v-card-actions>
      <slot name="button"></slot>
    </v-card-actions>
  </v-card>
</template>
<script>
import Editor from "@/components/Utils/Editor.vue";

export default {
  props: {
    value: {
      required: true,
      type: Object,
      default: () => {},
    },
    src: {
      required: false,
      type: String,
      default: require("@/assets/logo.png"),
    },
    hidden: {
      required: false,
      default: false,
      type: Boolean,
    },
    editable: {
      required: false,
      default: true,
      type: Boolean,
    },
  },
  components: {
    appEditor: Editor,
  },
};
</script>
<style scoped>
.v-icon {
  width: 152px;
}
.custom-rich-text {
  color: #29284c !important;
}
</style>
